import { Middleware } from '@reduxjs/toolkit';
import { setThemes } from './features/scenario.slice';
import { TConfiguration } from '@libs/types';
import { parseThemes } from '@libs/network-utils';

interface IAction {
    type: string;
    payload: {
        configuration: TConfiguration;
    };
}
enum EItems {
    THEMES = 'themes',
}
function assertAction(action: unknown): asserts action is IAction {
    if (typeof action !== 'object') {
        throw new Error('');
    }
}
function isFulfilledAction(action: unknown) {
    assertAction(action);
    return action.type === 'fetchScenario/fulfilled' || action.type === 'updateScenario/fulfilled';
}

export const localStorageMiddleware: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        const result = next(action);
        assertAction(action);
        if (isFulfilledAction(action)) {
            const { configuration = {} } = action.payload;
            const payloadThemesHash = configuration?.themesHash ?? '';
            const hasPayloadThemes = Array.isArray(configuration?.themes) && configuration.themes.length > 0;
            const stored = localStorage?.getItem(EItems.THEMES);
            const isValidStored = !!stored && !['undefined', 'null', '{}'].includes(stored);
            const storedHash = isValidStored ? JSON.parse(stored)?.themesHash : '';

            if (isValidStored && payloadThemesHash && storedHash && payloadThemesHash === storedHash) {
                dispatch(setThemes(JSON.parse(stored).themes));
            } else if (hasPayloadThemes && payloadThemesHash) {
                if (isValidStored) localStorage.removeItem(EItems.THEMES);
                const themes = parseThemes(configuration);
                localStorage.setItem(EItems.THEMES, JSON.stringify({ ...configuration, themes }));
                dispatch(setThemes(themes));
            }
        }
        return result;
    };
